<template>
  <div>
    <v-btn color="error" class="btn-delete" icon width="100%" @click="open">
      <v-icon>$vuetify.icons.trash</v-icon>
    </v-btn>
    <base-dialog
      v-model="visible"
      title="Delete Comparison"
      :buttons="buttons"
      @close="close"
    >
      Comparison will be deleted from the database
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/dialogs/BaseDialog'

export default {
  name: 'DeleteComparisonDialog',
  components: {
    BaseDialog,
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    buttons() {
      return [
        {
          handler: this.close,
          label: 'Cancel',
          type: 'text',
        },
        {
          handler: this.delete,
          label: 'Delete',
          type: 'error',
        },
      ];
    },
  },
  methods: {
    close() {
      this.visible = false
    },
    delete() {
      this.$emit('delete')
      this.close()
    },
    open() {
      this.visible = true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .btn-delete {
    path {
      fill: white;
      stroke: var(--v-error-base);
    }
  }
}
</style>
